
<div class="modal-content" *ngIf='IsShowDoctor'>
  <div class="card col-12 my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-10" *ngIf="DoctorType=='All'">
          Doctor Search
        </div>
        <div class="col-10" *ngIf="DoctorType=='DOCEX'">
          Doctor Search(Extenal)
        </div>
        <div class="col-10" *ngIf="DoctorType=='DOC'">
          Doctor Search(Internal)
        </div>
        <div class="col-10" *ngIf="DoctorType=='STAFF'">
          Staff
        </div>
        <div class="col-2">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">


      <div class="row margin-top-10  margin-left-10px">
        <div class="col-5">
          <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">
          <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
        </div>



      </div>
      <div class="row">
        <div class="col-12 padding-left-0px padding-right-0px">
          <div class="card">
            <div class="card-body margin-left-0px padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero "
                         cols="auto,2*,*,*,*,*,*,*">


                    <thead class="">
                      <tr>
                        <th class=""></th>
                        <th class="">
                          Name
                        </th>

                        <th class="">
                          Speciality
                        </th>


                        <!--<th class="">
                          Branch
                        </th>-->



                        <!--<th class="padding-left-0px">
                          Provider Type
                        </th>-->





                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of pdata">
                        <td class="padding-all-0px"><button type="button" class="btn font-size-13px actions-btn-prime" (click)="ProviderDetails(l)">Select</button></td>

                        <!--<td class="td-padding text-align-center">Mon</td>-->

                        <td class="padding-all-0px">{{l.Prefix}}{{l.DisplayName}}</td>
                        <!--<td class="td-padding text-align-center"></td>-->



                        <td class="">{{l.Specialty}}</td>
                        <!--<td class="">{{l.FacilityName}}</td>-->
                        <!--<td class="padding-all-0px">{{l.ProviderType}}</td>-->







                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
    <div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>

  </div>
</div>
<div class="modal-content" *ngIf='IsShowNurse'>
  <div class="card col-12 my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-10">
          Doctor Search
        </div>
        <div class="col-2">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">


      <div class="row margin-top-10  margin-left-10px">
        <div class="col-5">
          <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">
          <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
        </div>



      </div>
      <div class="row">
        <div class="col-12 padding-left-0px padding-right-0px">
          <div class="card">
            <div class="card-body margin-left-0px padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero "
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>
                        <th></th>
                        <th class="">
                          Name
                        </th>

                        <th class="">
                          Speciality
                        </th>


                        <!--<th class="">
                          Branch
                        </th>-->



                        <!--<th class="padding-left-0px">
                          Provider Type
                        </th>-->





                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentDoctorsListController">
                        <td class="padding-all-0px"><button type="button" class="btn font-size-13px actions-btn-prime" (click)="NurseDetails(l)">Select</button></td>

                        <!--<td class="td-padding text-align-center">Mon</td>-->

                        <td class="padding-all-0px">{{l.Prefix}}{{l.DisplayName}}</td>
                        <!--<td class="td-padding text-align-center"></td>-->



                        <td class="">{{l.Specialty}}</td>
                        <!--<td class="">{{l.FacilityName}}</td>-->
                        <!--<td class="padding-all-0px">{{l.ProviderType}}</td>-->







                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
    <div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>

  </div>
</div>
<div class="modal-content" *ngIf='IsShowProvieded'>
  <div class="card col-12 my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-10">
          Doctor Search
        </div>
        <div class="col-2">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">


      <div class="row margin-top-10  margin-left-10px">
        <div class="col-5">
          <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">
          <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
        </div>



      </div>
      <div class="row">
        <div class="col-12 padding-left-0px padding-right-0px">
          <div class="card">
            <div class="card-body margin-left-0px padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="table-component">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero "
                         cols="auto,2*,*,*,*,*,*,*">

                    <thead class="">
                      <tr>
                        <th></th>
                        <th class="">
                          Name
                        </th>

                        <th class="">
                          Speciality
                        </th>


                        <!--<th class="">
                          Branch
                        </th>-->



                        <!--<th class="padding-left-0px">
                          Provider Type
                        </th>-->





                      </tr>
                    </thead>

                    <tbody class="table-body">
                      <tr *ngFor="let l of CurrentDoctorsListController">
                        <td class="padding-all-0px"><button type="button" class="btn font-size-13px actions-btn-prime" (click)="ProvidedDetails(l)">Select</button></td>

                        <!--<td class="td-padding text-align-center">Mon</td>-->

                        <td class="padding-all-0px">{{l.Prefix}}{{l.DisplayName}}</td>
                        <!--<td class="td-padding text-align-center"></td>-->



                        <td class="">{{l.Specialty}}</td>
                        <!--<td class="">{{l.FacilityName}}</td>-->
                        <!--<td class="padding-all-0px">{{l.ProviderType}}</td>-->







                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
    <div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

    </div>

  </div>
</div>

<div class="modal-content" *ngIf="DoctorType=='DOCEX'">
  <div class="card col-12 my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">

        <div class="col-10">
          Doctor Search(Extenal)
        </div>

        <div class="col-2">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px padding-bottom-0px">
      <ul class="nav nav-tabs nav-tab-service margin-top-13px" id="tabContent">
        <li class="active margin-right-5px"><a class="nav-item2 active" href="#List" data-toggle="tab">List</a></li>
        <li class="margin-right-5px"><a class="nav-item2" href="#New" data-toggle="tab">Add New</a></li>

      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="List">
          <div class="card">
            <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
              <div class="row margin-top-10  margin-left-10px margin-bottom-5px">
                <div class="col-5">
                  <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange2($event.target.value)">
                  <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
                </div>



              </div>
              <div class="row counselling-modal margin-top-5px">
                <div class="col-12 padding-left-0px padding-right-0px">
                  <div class="card">
                    <div class="card-body margin-left-0px padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
                      <div class="table-component">
                        <div class="table-responsive overflow-x">


                          <table class="table table-striped margin-left-zero "
                                 cols="auto,2*,*,*,*,*,*,*">

                            <thead class="">
                              <tr>
                                <th class=""></th>
                                <th class="padding-left-0px">
                                  Name
                                </th>

                                <!--<th class="">
                                  Speciality
                                </th>-->


                                <th class="padding-left-0px">
                                  Institute
                                </th>



                                <!--<th class="padding-left-0px">
                                  Contact
                                </th>-->





                              </tr>
                            </thead>

                            <tbody class="table-body">
                              <tr *ngFor="let l of pdata2">
                                <td class="padding-all-0px"><button type="button" class="btn font-size-13px actions-btn-prime" (click)="ProviderDetails2(l)">Select</button></td>

                                <!--<td class="td-padding text-align-center">Mon</td>-->

                                <td class="padding-all-0px">{{l.Prefix}}{{l.DisplayName}}</td>
                                <!--<td class="td-padding text-align-center"></td>-->



                                <td class="padding-all-0px">{{l.ClinicName}}</td>
                                <!--<td class="padding-all-0px">{{l.Telephone1}}</td>-->








                              </tr>

                            </tbody>

                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="card-footer text-align-right padding-top-5px padding-bottom-5px">
              <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>

            </div>
          </div>


        </div>



        <div class="tab-pane" id="New">

          <form class="form" novalidate="" (ngSubmit)="onSubmitExternal()" #f="ngForm">

            <div class="card card-height-417px">

              <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                <div class="row">
                  <div class="col-12 padding-l-0px">
                    <div class="card col-12 my-profile-form padding-lr-0px">

                      <div class="card-body card-body-general">
                        <div class="row">
                          <div class="form-group col-12 margin-bottom-5px">
                            <div class="row">
                              <div class="col-5 text-align-right margin-top-5px">
                                <label for="diaplayName">Name</label>
                              </div>
                              <div class="col-7">
                                <input type="text" class="form-control" placeholder="First Name"
                                       id="CurrentSaveExternalDoctorInfoRequest.DoctorName"
                                       [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.DoctorName"
                                       name="CurrentSaveExternalDoctorInfoRequest.DoctorName" pattern="^[\sa-zA-Z,._\-?]*$"
                                       maxlength="30" minlength="1" #DisplayName="ngModel" required>
                                <small class="form-text text-danger"
                                       *ngIf="(!DisplayName.valid && (DisplayName.dirty || DisplayName.touched) && DisplayName.errors.required )">(Field cannot be left blank)</small>
                                <small class="form-text text-danger"
                                       *ngIf="(!DisplayName.valid && DisplayName.errors.pattern)">(special characters are not allowed)</small>
                              </div>
                            </div>


                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-12 margin-bottom-5px">
                            <div class="row">

                              <div class="col-5 text-align-right margin-top-5px">
                                <label for="email address">Contact Number</label>
                              </div>
                              <div class="col-7">
                                <input type="tel" class="form-control" placeholder="Mobile Phone"
                                       id="CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo"
                                       [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.DoctorPhoneNo"
                                       mask="(000) 000-0000"
                                       name="CurrentSaveExternalDoctorRequest.DoctorPhoneNo" pattern="[0-9]{10}" #Telephone1="ngModel">
                                <small class="form-text text-danger"
                                       *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-12 margin-bottom-5px">
                            <div class="row">

                              <div class="col-5 text-align-right margin-top-5px">
                                <label for="email address">Institute</label>
                              </div>
                              <div class="col-7">
                                <input type="text" class="form-control" placeholder="Institute"
                                       id="CurrentSaveExternalDoctorInfoRequest.DoctorInstitute"
                                       [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.DoctorInstitute"
                                       name="CurrentSaveExternalDoctorInfoRequest.DoctorInstitute" pattern="^[\sa-zA-Z,._\-?]*$"
                                       maxlength="30" minlength="1" #InstituteName="ngModel">
                                <small class="form-text text-danger"
                                       *ngIf="(!InstituteName.valid && (InstituteName.dirty || InstituteName.touched) && InstituteName.errors.required )">(Field cannot be left blank)</small>

                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-top-5px">
                          <div class="form-group col-12 margin-bottom-5px">
                            <div class="row">

                              <div class="col-5 text-align-right margin-top-5px">
                                <label for="email address">Location </label>
                              </div>
                              <div class="col-7">
                                <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Location"
                                          name="CurrentSaveExternalDoctorInfoRequest.Location"
                                          [(ngModel)]="CurrentSaveExternalDoctorInfoRequest.Location" minlength="1" maxlength="100"
                                          #addconcerns_text1="ngModel"></textarea>
                                <small class="form-text text-danger"
                                       *ngIf="(!addconcerns_text1.valid && (addconcerns_text1.dirty || addconcerns_text1.touched))">(Required)</small>

                              </div>                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer padding-top-5px padding-bottom-5px">
                <button type="button" class="btn btn-secondary btn-raised float-right margin-left-3px button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
                <button type="submit" class="btn actions-btn-prime float-right font-size-13px">Save</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
